import { render, staticRenderFns } from "./VueGridItem.vue?vue&type=template&id=7a48b4f8&"
import script from "./VueGridItem.vue?vue&type=script&lang=ts&"
export * from "./VueGridItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports